import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of, tap } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ContentService {
   private readonly storageKey = 'lsr_privacy_html_v1';
   private readonly storageKeyPolicyForm = 'lsr_privacypolicy_html_v1';
  private readonly privacyPath = 'assets/lsr/privacy/privacy.txt';
  private readonly privacyPolicyFormPath = 'assets/lsr/privacy/privacy-policy-form.txt';

  constructor(private http: HttpClient) {}

 getPrivacyHtml(): Observable<string> {
    const cached = localStorage.getItem(this.storageKey);
    if (cached) {
      return of(cached);
    }

    return this.http.get(this.privacyPath, { responseType: 'text' }).pipe(
      tap((html) => localStorage.setItem(this.storageKey, html))
    );
  } 
   getPrivacyPolicyFormHtml(): Observable<string> {
    const cached = localStorage.getItem(this.storageKeyPolicyForm);
    if (cached) {
      return of(cached);
    }

    return this.http.get(this.privacyPolicyFormPath, { responseType: 'text' }).pipe(
      tap((html) => localStorage.setItem(this.storageKeyPolicyForm, html))
    );
  } 
}